import { Colors_AlertsPositiveDark, Colors_LightBlue } from "../Design.js";
import { strIContains } from "../Shared/Shared.js";
import { int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Checkbox, FormControlLabel } from "@mui/material";

export function getColor(orderType) {
    switch (orderType.tag) {
        case 2:
            return Colors_LightBlue(1);
        case 3:
            return "rgba(91, 127, 149, 1)";
        case 0:
        case 4:
            return Colors_AlertsPositiveDark;
        default:
            return "rgba(255, 205, 0, 1)";
    }
}

export function filter(term, orders) {
    const contains = (str) => strIContains(term, str);
    return orders.filter((o) => {
        let inTicket;
        const matchValue = o.TicketId;
        if (matchValue != null) {
            const t = matchValue | 0;
            inTicket = (int32ToString(t).indexOf(term) >= 0);
        }
        else {
            inTicket = false;
        }
        if (contains(int32ToString(o.Number)) ? true : inTicket) {
            return true;
        }
        else {
            return contains(o.Customer.Name);
        }
    });
}

export function filterBox(label, isChecked, onChange) {
    return MuiHelpers_createElement(FormControlLabel, [["label", label], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"], ["onChange", (e) => {
        onChange(e.target.checked);
    }], ["checked", isChecked]])]]);
}

